module.exports = __webpack_public_path__ + "img/china-eastern.a0d9b04a.png";